import { render, staticRenderFns } from "./dbuy.vue?vue&type=template&id=2ee1fab3&"
import script from "./dbuy.vue?vue&type=script&lang=js&"
export * from "./dbuy.vue?vue&type=script&lang=js&"
import style0 from "./dbuy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports